export const defaultBulletinPdfDraftSaveStatus = {
  status: 'idle',
  savedAt: null,
  error: null,
};

export const bulletinPdfDraftInitialState = {
  bulletinId: null,
  pdfTemplate: 'default',
  isPageReady: false,
  phase: 'loading',
  hasPendingDraft: false,
  pendingDomApply: false,
  draftRevision: 0,
  draftUpdatedAt: null,
  saveStatus: defaultBulletinPdfDraftSaveStatus,
  introductionEnabled: false,
};
